
window.PB_ROUTE = window.PB_ROUTE || (k => (window.PB_ROUTES && window.PB_ROUTES[k]) ||
  ({ cartAdd: '/cart/add', cartAddJs: '/cart/add.js', cartUpdateJs: '/cart/update.js', checkout: '/checkout' })[k]);

(() => {
  'use strict';
  const CFG = window.PB_SHOPIFY || {};
  const onShopify = !!(window.Shopify && window.Shopify.shop) || document.documentElement.hasAttribute('data-shopify');
  const q = (s, r = document) => r.querySelector(s);
  const all = (s, r = document) => [...r.querySelectorAll(s)];
  const money = c => '$' + (c / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  
  function reference(kind) {
    const t = Date.now().toString(36).toUpperCase().slice(-6);
    const r = Math.random().toString(36).toUpperCase().slice(2, 6);
    return (kind === 'cover' ? 'PBC-' : 'PBS-') + t + '-' + r;
  }

  // ------------------------------------------------------------------ drawer
  let root = null, state = null, busy = false;

  function build() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'pb-order';
    root.hidden = true;
    root.innerHTML = `
      <div class="pb-order__scrim" data-close></div>
      <section class="pb-order__panel" role="dialog" aria-modal="true" aria-labelledby="pb-order-title">
        <header class="pb-order__head">
          <p class="pb-order__kicker" data-kicker></p>
          <h2 class="pb-order__title" id="pb-order-title" data-title></h2>
          <button type="button" class="pb-order__x" data-close aria-label="Close">&times;</button>
        </header>
        <div class="pb-order__body">
          <div class="pb-order__spec">
            <h3>Your configuration</h3>
            <dl data-spec></dl>
            <p class="pb-order__amend" data-amend></p>
          </div>
          <form class="pb-order__form" novalidate>
            <div class="pb-order__row">
              <label class="pb-order__field">Full name
                <input name="name" type="text" autocomplete="name" required>
              </label>
              <label class="pb-order__field">Email
                <input name="email" type="email" autocomplete="email" required>
              </label>
            </div>
            <div class="pb-order__row">
              <label class="pb-order__field">Phone
                <input name="phone" type="tel" autocomplete="tel" required>
              </label>
              <label class="pb-order__field">Quantity
                <input name="quantity" type="number" min="1" max="5" step="1" value="1" inputmode="numeric">
              </label>
            </div>
            <label class="pb-order__field">Delivery address
              <input name="address" type="text" autocomplete="street-address" placeholder="Street, municipality, postal code">
            </label>
            <label class="pb-order__field">Anything we should know
              <textarea name="notes" rows="2" placeholder="Access, gates, timing, electrical…"></textarea>
            </label>
            <div class="pb-order__total">
              <span>Total</span><strong data-total>Confirmed at checkout</strong>
            </div>
            <p class="pb-order__err" data-error hidden role="alert"></p>
            <button type="submit" class="pb-order__go" data-go>
              <span data-go-label>Continue to secure payment</span>
              <span class="pb-order__spin" aria-hidden="true"></span>
            </button>
            <p class="pb-order__fine" data-fine>Payment is taken by Shopify's secure checkout. Pool Busters confirms
              lead time, delivery access and electrical before your order is placed with the manufacturer.</p>
          </form>
        </div>
      </section>`;
    document.body.append(root);
    all('[data-close]', root).forEach(b => b.addEventListener('click', close));
    addEventListener('keydown', e => { if (e.key === 'Escape' && !root.hidden && !busy) close(); });
    q('.pb-order__form', root).addEventListener('submit', submit);
    return root;
  }

  function close(force) {
    if (!root || (busy && !force)) return;
    root.hidden = true;
    document.documentElement.classList.remove('pb-order-open');
    state && state.opener && state.opener.focus();
  }

  
  function open(spec) {
    build();
    state = spec;
    q('[data-kicker]', root).textContent = spec.kicker;
    q('[data-title]', root).textContent = spec.title;
    const dl = q('[data-spec]', root);
    dl.replaceChildren(...spec.lines.flatMap(([k, v]) => {
      const dt = document.createElement('dt'); dt.textContent = k;
      const dd = document.createElement('dd'); dd.textContent = v;
      return [dt, dd];
    }));
    q('[data-amend]', root).textContent = spec.amend || '';
    const total = q('[data-total]', root);
    total.textContent = Number.isFinite(spec.price) ? money(spec.price) + ' CAD'
      : spec.quoted ? 'Quoted by Pool Busters' : 'Confirmed at checkout';
    const go = q('[data-go]', root), label = q('[data-go-label]', root), fine = q('[data-fine]', root);
    const ready = Number.isFinite(spec.variantId) && spec.variantId > 0;
    go.disabled = false;
    label.textContent = ready ? 'Continue to secure payment' : 'Send this specification to Pool Busters';
    fine.textContent = ready
      ? "Payment is taken by Shopify's secure checkout. Pool Busters confirms lead time, delivery access and electrical before your order is placed with the manufacturer."
      : 'Online payment for this product is not switched on yet, so this goes to Pool Busters as a complete order request and a member of the team will take payment with you.';
    error('');
    busy = false;                                      // a fresh specification, a fresh attempt
    root.classList.remove('is-working');
    root.hidden = false;
    document.documentElement.classList.add('pb-order-open');
    setTimeout(() => q('input[name=name]', root).focus(), 60);
  }

  const error = msg => {
    const el = q('[data-error]', root);
    el.textContent = msg; el.hidden = !msg;
  };

  // ------------------------------------------------------------------ submit
  async function submit(e) {
    e.preventDefault();
    if (busy) return;                                  // a second click changes nothing
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form).entries());
    if (!data.name || !data.email || !data.phone) { error('Name, email and phone are needed to place the order.'); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)) { error('That email address does not look right.'); return; }
    const qty = Math.max(1, Math.min(5, parseInt(data.quantity, 10) || 1));

    busy = true;
    root.classList.add('is-working');
    q('[data-go]', root).disabled = true;
    error('');
    const ref = state.ref || (state.ref = reference(state.kind));

    try {
      const props = Object.assign({}, state.properties, {
        'Order reference': ref,
        'Contact name': data.name,
        'Contact email': data.email,
        'Contact phone': data.phone,
      });
      if (data.address) props['Delivery address'] = data.address;
      if (data.notes) props['Customer notes'] = data.notes;

      const ready = Number.isFinite(state.variantId) && state.variantId > 0;
      if (!ready || !onShopify) { requestInstead(props, data, ref); return; }

      const add = await fetch(PB_ROUTE('cartAddJs'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variantId, quantity: qty, properties: props }] }),
      });
      if (!add.ok) {
        const err = await add.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Shopify could not take that order line.');
      }
      
      await fetch(PB_ROUTE('cartUpdateJs'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {
          'Order reference': ref,
          'Order type': state.kind === 'cover' ? 'CUSTOM SPA COVER ORDER' : 'HOT TUB ORDER',
          'Configured on': new Date().toISOString(),
        } }),
      }).catch(() => {});                              // the cart line is what matters

      
      location.href = PB_ROUTE('checkout') + '?checkout%5Bemail%5D=' + encodeURIComponent(data.email);
    } catch (err) {
      
      error(err.message + ' Your configuration is still here — try again, or call 289 929 7665.');
      busy = false;
      root.classList.remove('is-working');
      q('[data-go]', root).disabled = false;
    }
  }

  
  async function requestInstead(props, data, ref, ready) {
    const lines = Object.entries(props).map(([k, v]) => k + ': ' + v).join('\n');
    const body = (state.kind === 'cover' ? 'CUSTOM SPA COVER ORDER REQUEST' : 'HOT TUB ORDER REQUEST')
      + '\nReference: ' + ref + '\n' + new Date().toLocaleString('en-CA') + '\n\n' + lines;
    const field = q('#pbht-ld-msg') || q('#cover-form [name=message]');
    if (field) {
      field.value = (field.value ? field.value.trim() + '\n\n' : '') + body;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      for (const [name, value] of [['name', data.name], ['email', data.email], ['phone', data.phone], ['town', data.address]]) {
        const el = q('#hot-tub-contact [name=' + name + '], #cover-form [name=' + name + ']');
        if (el && value && !el.value) { el.value = value; el.dispatchEvent(new Event('input', { bubbles: true })); }
      }
    }
    root.classList.remove('is-working');
    close(true);
    const target = q('#hot-tub-contact') || q('#cover-builder');
    if (target) target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
    say('Your specification has been carried into the form below, reference ' + ref
      + '. Send it and Pool Busters will take payment with you.');
  }

  function say(message) {
    let el = q('.pb-cart-note');
    if (!el) { el = document.createElement('div'); el.className = 'pb-cart-note'; el.setAttribute('role', 'status'); document.body.append(el); }
    el.innerHTML = '<p>' + message + '</p><button type="button" class="pb-cart-note__x" aria-label="Dismiss">&times;</button>';
    el.classList.add('is-on');
    el.querySelector('.pb-cart-note__x').onclick = () => el.classList.remove('is-on');
  }

  // ------------------------------------------------------------ spa ordering
  function spa(opener, code) {
    const models = window.PB_HT?.models || [];
    const m = models.find(x => x.code === code) || models.find(x => x.code === '743L-230') || models[0];
    if (!m) return;
    const panel = q('[data-pb-order]');
    const pick = n => (panel && q('[name="properties[' + n + ']"]', panel)?.value) || 'Recommend one for me';
    const cfg = CFG.hotTubs?.[m.code] || {};
    const priced = window.PB_PRICING?.hotTubs?.[m.code];
    open({
      kind: 'spa', opener, variantId: cfg.variantId,
      price: priced ? Math.round(priced.retail * 100) : cfg.price,
      kicker: 'Order your spa',
      title: m.name + ' · ' + m.variant,
      lines: [
        ['Model', m.name + ' ' + m.variant],
        ['Voltage', m.voltage + ' V'],
        ['Seating', m.seatsLabel],
        ['Jets', String(m.jets)],
        ['Footprint', m.dims.w + '" × ' + m.dims.l + '" × ' + m.dims.h + '"'],
        ['Shell finish', pick('Shell finish')],
        ['Cabinet finish', pick('Cabinet finish')],
      ],
      amend: 'Finishes are chosen in "Bring one home" above; everything else is this model\'s specification.',
      properties: {
        'Order type': 'HOT TUB ORDER',
        Model: m.name + ' ' + m.variant,
        Voltage: m.voltage + ' V',
        Seating: m.seatsLabel,
        Jets: String(m.jets),
        Footprint: m.dims.w + '" × ' + m.dims.l + '" × ' + m.dims.h + '"',
        'Shell finish': pick('Shell finish'),
        'Cabinet finish': pick('Cabinet finish'),
      },
    });
  }

  // ---------------------------------------------------------- cover ordering
  function cover(opener) {
    const form = q('#cover-form'); if (!form) return;
    const D = window.PB_HT?.cover;
    const v = n => (form.elements[n]?.value || '').trim();
    const colour = D && D.colours[Number(v('colour')) || 0];
    const upgrades = all('[name=upgrade]:checked', form).map(el => el.value).join(', ');
    const shapeName = (D && D.shapes.find(s => s.id === v('shape'))?.name) || v('shape');
    const inches = n => (v(n) ? v(n) + '"' : 'to be confirmed');
    const lines = [
      ['Shape', shapeName],
      ['A · side', inches('dimA')],
      ['B · side', inches('dimB')],
      ['C · corner', inches('dimC')],
      ['Skirt', v('skirt') === 'Other / match my old cover' && v('skirtOther') ? v('skirtOther') + '"' : (v('skirt') || 'to be confirmed')],
      ['Taper', v('taper') || 'to be confirmed'],
      ['Fold', [v('fold'), v('foldDir')].filter(Boolean).join(' · ') || 'to be confirmed'],
      ['Material', colour ? colour.material : '—'],
      ['Colour', colour ? colour.name : '—'],
      ['Vapour barrier', v('vapour') || 'to be confirmed'],
      ['Speaker hoods', v('hoods') || 'None'],
      ['Upgrades', [upgrades, form.elements.foam?.checked ? '2 lb foam' : '', v('bundle')].filter(Boolean).join(', ') || 'None'],
      ['Spa', [v('brand'), v('model'), v('year')].filter(Boolean).join(' ') || 'Not given'],
    ];
    
    const cfg = CFG.cover || {};
    open({
      kind: 'cover', opener, variantId: cfg.variantId, price: null, quoted: true,
      kicker: 'Order your cover',
      title: 'Made-to-measure spa cover',
      lines,
      amend: 'Measurements are checked by Pool Busters before the cover goes into production.',
      properties: Object.assign({ 'Order type': 'CUSTOM SPA COVER ORDER' },
        Object.fromEntries(lines.map(([k, val]) => [k, val])),
        form.elements.measurementHelp?.checked ? { 'Measurement help requested': 'Yes' } : {}),
    });
  }

  // --------------------------------------------------------------- wiring up
  addEventListener('DOMContentLoaded', () => {
    
    const heroBtn = q('.lx-hero__actions .lx-button--light, [data-pb-order-now]');
    if (heroBtn) heroBtn.addEventListener('click', e => {
      e.preventDefault();
      const checked = q('.lx-hero__models [data-model][aria-checked="true"]');
      spa(heroBtn, checked?.dataset.model);
    });
    
    const panel = q('[data-pb-order]');
    if (panel) q('form', panel)?.addEventListener('submit', e => {
      e.preventDefault();
      const checked = q('[data-pb-order-model][aria-checked="true"]', panel);
      spa(q('[type=submit]', panel), checked?.dataset.pbOrderModel);
    }, true);
    
    const review = q('#cover-review');
    if (review) {
      const go = document.createElement('button');
      go.type = 'button';
      go.className = 'action pb-order__open';
      go.textContent = 'Order this cover';
      go.addEventListener('click', () => cover(go));
      review.insertBefore(go, q('#download-cover', review));
    }
  });

  window.PB_ORDER = { spa, cover, open, reference };
})();
